import {Component, inject, Input, OnInit} from '@angular/core';
import {LoginComponent} from '../../../authentication/components/login/login.component';
import {TranslocoPipe} from '@jsverse/transloco';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {RedirectService} from '../../../../core/services/redirect.service';

@Component({
  selector: 'app-booking-login',
  imports: [
    LoginComponent,
    TranslocoPipe,
    IconButtonComponent
  ],
  templateUrl: './booking-login.component.html',
  styleUrl: './booking-login.component.scss'
})
export class BookingLoginComponent implements OnInit {
  @Input() mobile = true;

  location: Location = inject(Location);
  router: Router = inject(Router);
  redirect: RedirectService = inject(RedirectService);

  ngOnInit() {
    this.redirect.set({url: "/booking/confirm"})
  }

  back() {
    this.location.back();
  }
}
